import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingController, ModalController, NavController, ToastController } from '@ionic/angular';
import { ModalHelpDepositComponent } from 'src/app/components/modals/modal-help-deposit/modal-help-deposit.component';
import { ModalQrCodeComponent } from 'src/app/components/modals/modal-qr-code/modal-qr-code.component';
import { OrderService } from 'src/app/services/order.service';
import { Security } from 'src/app/utils/security.util';

@Component({
  selector: 'app-make-deposit',
  templateUrl: './make-deposit.page.html',
  styleUrls: ['./make-deposit.page.scss'],
})
export class MakeDepositPage implements OnInit {

  form: FormGroup;
  img: any = null;
  vm = false;
  currentId = 0;
  sellersPermitFile: any;
  driversLicenseFile: any;
  tmCoin = 0;
  sendReceipt = 1;
  // sendReceipt = 0;

  constructor(private orderSerice: OrderService, private fb: FormBuilder, private toastCtrl: ToastController,
    private loadingCtrl: LoadingController, private modalCrtl: ModalController, private navCtrl: NavController) {
    this.form = this.fb.group({
      receipt: ['', Validators.compose([
        Validators.required
      ])],
      bondCoin: [''],
      value: ['', Validators.compose([
        Validators.required
      ])],
      typeDeposit: []
    });
  }

  ngOnInit() {
    if (this.returnBondCoin() === 1) {
      this.form.patchValue({
        bondCoin: 1,
        receipt: ' ',
        // typeDeposit: 2
        typeDeposit: 1
      });

      this.tmCoin = 1;
    } else {
      this.form.patchValue({
        bondCoin: this.returnBondCoin(),
        typeDeposit: 1
      });
    }


    // this.openQrCode(2);

  }

  async changeSendReceipt(){
    this.sendReceipt = 1;

    this.form.patchValue({
      typeDeposit: 1
    });
  }

  async save() {
    const loading = await this.loadingCtrl.create({ message: 'Gerando Ordem...' });
    loading.present();

    this.orderSerice.resourceDeposit(this.form.value).subscribe(result => {
      if (result.success) {
        this.showMessage(result.message);
        loading.dismiss();
        if (this.tmCoin === 1 && this.sendReceipt === 0) {
          this.openQrCode(result.data);
        } else {
          this.goToPage('/master/wallet/home');
        }
      } else {
        this.showMessage(result.message);
        loading.dismiss();
        console.log(result.data);
      }
    }, error => {
      this.showMessage(error.message);
      console.log(error.message);
      loading.dismiss();
    });
  }

  async showMessage(messagen) {
    const error = await this.toastCtrl.create({ message: messagen, duration: 3000 });
    error.present();
  }

  close() {
    this.modalCrtl.dismiss();
  }

  goToPage(page) {
    this.navCtrl.navigateRoot(page);
  }

  async openQrCode(qrcode) {
    const modal = await this.modalCrtl.create({
      component: ModalQrCodeComponent,
      componentProps: {
        data: qrcode
      }
    });

    modal.onDidDismiss().then(() => {
      this.goToPage('/master/wallet/home');
    });

    modal.present();

  }

  async openHelper() {
    const modal = await this.modalCrtl.create({
      component: ModalHelpDepositComponent
    });

    modal.onDidDismiss().then(() => {
      this.ngOnInit();
    });

    modal.present();

  }

  // Upload Base64
  picked(event, field) {
    this.currentId = field;
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      if (field === 1) {
        this.sellersPermitFile = file;
        this.handleInputChange(file); // turn into base64
      } else if (field === 2) {
        this.driversLicenseFile = file;
        this.handleInputChange(file); // turn into base64
      }
    } else {
      alert('Falha ao carregar as imagens');
    }
  }

  handleInputChange(files) {
    const file = files;
    const pattern = /image-*/;
    const reader = new FileReader();
    if (!file.type.match(pattern)) {
      alert('invalid format');
      return;
    }
    reader.onloadend = this._handleReaderLoaded.bind(this);
    reader.readAsDataURL(file);
  }

  _handleReaderLoaded(e) {
    const reader = e.target;
    const base64result = reader.result.substr(reader.result.indexOf(',') + 1);
    // this.imageSrc = base64result;
    const id = this.currentId;
    switch (id) {
      case 1:
        this.form.patchValue({
          receipt: base64result,
        });
        this.img = base64result;
        this.vm = true;
        break;
    }
  }

  returnBondCoin() {
    switch (Security.getCoin()) {
      case '1':
        return 1;
      case '2':
        return 2;
      case '3':
        return 3;
    }
  }

}
